<template>
    <BigCard title="Montant sollicite">
        <template slot="icon">
            <svg
                width="40"
                height="40"
                class="p-2"
                viewBox="0 0 14 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.999919 0H12.9999C13.1767 0 13.3463 0.0702379 13.4713 0.195262C13.5963 0.320286 13.6666 0.489856 13.6666 0.666667V11.3333C13.6666 11.5101 13.5963 11.6797 13.4713 11.8047C13.3463 11.9298 13.1767 12 12.9999 12H0.999919C0.823108 12 0.653538 11.9298 0.528514 11.8047C0.40349 11.6797 0.333252 11.5101 0.333252 11.3333V0.666667C0.333252 0.489856 0.40349 0.320286 0.528514 0.195262C0.653538 0.0702379 0.823108 0 0.999919 0ZM1.66659 1.33333V10.6667H12.3333V1.33333H1.66659ZM4.66659 7.33333H8.33325C8.42166 7.33333 8.50644 7.29821 8.56895 7.2357C8.63147 7.17319 8.66659 7.08841 8.66659 7C8.66659 6.91159 8.63147 6.82681 8.56895 6.7643C8.50644 6.70179 8.42166 6.66667 8.33325 6.66667H5.66659C5.22456 6.66667 4.80063 6.49107 4.48807 6.17851C4.17551 5.86595 3.99992 5.44203 3.99992 5C3.99992 4.55797 4.17551 4.13405 4.48807 3.82149C4.80063 3.50893 5.22456 3.33333 5.66659 3.33333H6.33325V2H7.66659V3.33333H9.33325V4.66667H5.66659C5.57818 4.66667 5.49339 4.70179 5.43088 4.7643C5.36837 4.82681 5.33325 4.91159 5.33325 5C5.33325 5.08841 5.36837 5.17319 5.43088 5.2357C5.49339 5.29821 5.57818 5.33333 5.66659 5.33333H8.33325C8.77528 5.33333 9.1992 5.50893 9.51176 5.82149C9.82432 6.13405 9.99992 6.55797 9.99992 7C9.99992 7.44203 9.82432 7.86595 9.51176 8.17851C9.1992 8.49107 8.77528 8.66667 8.33325 8.66667H7.66659V10H6.33325V8.66667H4.66659V7.33333Z"
                    fill="white"
                />
            </svg>
        </template>
        <template>
            <div class="flex justify-center content-center py-7">
                <apexchart
                    class="w-full"
                    type="pie"
                    :options="chartOptions"
                    :series="series"
                ></apexchart>
            </div>
        </template>
    </BigCard>
</template>

<script>
import BigCard from "../cardWithIcon.vue";
import VueApexCharts from "vue-apexcharts";

export default {
    components: {
        BigCard,
        VueApexCharts
    },
    created() {
        this.montants.forEach(montant => {
            if (montant >= 0 && montant <= 100000) {
                this.firstValue++;
            } else if (montant > 100000 && montant <= 300000) {
                this.secondValue++;
            } else if (montant > 300000 && montant <= 500000) {
                this.thirdValue++;
            } else {
                this.fourthValue++;
            }
        });
        let labels = [
            "< A 100,000 dh",
            "Entre 100,000 et 300,000 dh",
            "Entre 300,000 et 500,000 dh",
            "> A 500,000 dh"
        ];
        this.series = [
            this.firstValue,
            this.secondValue,
            this.thirdValue,
            this.fourthValue
        ];

        this.chartOptions = {
            chart: {
                width: 380,
                type: "pie"
            },
            legend: {
                show: false
            },
            labels: labels,
            colors: ["#FBBF24", "#FB923C", "#818CF8", "#34D399"],
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: "bottom"
                        }
                    }
                }
            ]
        };
    },
    props: {
        montants: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            series: [],
            chartOptions: {},
            firstValue: 0,
            secondValue: 0,
            thirdValue: 0,
            fourthValue: 0
        };
    }
};
</script>

<style></style>
